import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';

import { IError, IServerErrorResponse } from '../../../types';
import { endpointManager } from '../../../services/endpoint.service';

export interface IMoveMoneyLimits {
  singleLimit: number | undefined;
  dailyLimit: number | undefined;
  monthlyLimit: number | undefined;
  balance: number;
}

export const getWireLimits = (onError: (err: IError) => void) => {
  const { getWireLimitsUrl } = endpointManager();

  return useQuery(
    'getWireLimits',
    async (): Promise<IMoveMoneyLimits> => {
      const res = await httpService.get(getWireLimitsUrl());
      return res.data;
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onError: (e: IServerErrorResponse) => {
        onError(e?.response?.data?.errors?.[0]);
      },
    },
  );
};
